import Vue from 'vue'
import VueRouter from 'vue-router'
import { defaults } from 'axios'
import { getCookie } from '../tools'
import { routes, setApiUrl, tokenName } from '../config'

// API-Url setzen
setApiUrl('default')

// Authorisierung initialisieren und ggf Token aus Cookie holen
defaults.headers.common['Authorization'] = undefined
var token = getCookie(tokenName)
if (token != undefined)
    defaults.headers.common['Authorization'] = "bearer " + token

// Router konfigurieren
Vue.use(VueRouter)
const router = new VueRouter({ routes })
router.beforeEach((to, from, next) => {
    if (defaults.headers.common['Authorization'] != undefined && (to.path == '/login' || to.path == '/register'))
    next('/')
    else if (defaults.headers.common['Authorization'] == undefined && to.path != '/login' && to.path != '/register' && to.path != '/impressum')
    next('/login')
  else
    next()
})

export default router
